(function () {
  function initCollectionListCarousel() {
    // pega todas as seções que contém um Collection list
    const grids = document.querySelectorAll('.shopify-section .collection-list.grid');

    grids.forEach((grid) => {
      // evita duplicar caso rode de novo
      if (grid.dataset.carouselInit === '1') return;
      grid.dataset.carouselInit = '1';

      // só aplica no desktop
      const isDesktop = window.matchMedia('(min-width: 990px)').matches;
      if (!isDesktop) return;

      // cria wrapper relativo (para setas)
      const parentSection = grid.closest('.shopify-section');
      if (!parentSection) return;

      // garante que a área das setas “segure” grid + botões
      let wrap = grid.closest('.cl-carousel-wrap');
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'cl-carousel-wrap';
        grid.parentNode.insertBefore(wrap, grid);
        wrap.appendChild(grid);
      }

      // cria nav
      const nav = document.createElement('div');
      nav.className = 'cl-carousel-nav';

      const prev = document.createElement('button');
      prev.className = 'cl-carousel-btn prev';
      prev.type = 'button';
      prev.setAttribute('aria-label', 'Previous');
      prev.innerHTML = '&#x2039;'; // ‹

      const next = document.createElement('button');
      next.className = 'cl-carousel-btn next';
      next.type = 'button';
      next.setAttribute('aria-label', 'Next');
      next.innerHTML = '&#x203A;'; // ›

      nav.appendChild(prev);
      nav.appendChild(next);
      wrap.appendChild(nav);

      function getStep() {
        const firstItem = grid.children && grid.children.length ? grid.children[0] : null;
        if (!firstItem) return 300;
        const gap = parseFloat(getComputedStyle(grid).gap || '24') || 24;
        return firstItem.getBoundingClientRect().width + gap;
      }

      prev.addEventListener('click', () => {
        grid.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        grid.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    });
  }

  // roda ao carregar e ao redimensionar
  window.addEventListener('load', initCollectionListCarousel);
  window.addEventListener('resize', () => {
    // simples: recarrega a página não; só tenta inicializar de novo.
    // (O dataset evita duplicar em desktop)
    initCollectionListCarousel();
  });

  // Shopify editor (quando você mexe no customize)
  document.addEventListener('shopify:section:load', initCollectionListCarousel);
})();